import { render, staticRenderFns } from "./MessagingDescriptionCheckBox.vue?vue&type=template&id=0e0182dc&scoped=true&"
import script from "./MessagingDescriptionCheckBox.vue?vue&type=script&lang=js&"
export * from "./MessagingDescriptionCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./MessagingDescriptionCheckBox.vue?vue&type=style&index=0&id=0e0182dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0182dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3744633428/src/vbc-messaging-10-dlc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e0182dc')) {
      api.createRecord('0e0182dc', component.options)
    } else {
      api.reload('0e0182dc', component.options)
    }
    module.hot.accept("./MessagingDescriptionCheckBox.vue?vue&type=template&id=0e0182dc&scoped=true&", function () {
      api.rerender('0e0182dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/smsRegistrationComponents/MessagingDescriptionCheckBox.vue"
export default component.exports